export enum TrackableEventType {
	OnClick = 'onClick',
	OnFocus = 'onFocus',
	OnBlur = 'onBlur',
	OnChange = 'onChange',
	OnKeyDown = 'onKeyDown',
	OnDrag = 'onDrag',
}
